"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@osmosys/react");
exports.useMappingCanvas = (key) => {
    return react_1.useCanvas(key);
};
//# sourceMappingURL=useMappingCanvas.js.map